<template>
  <div class="chart-container">
    <Bar
      ref="chartRef"
      :data="chartData"
      :options="chartOptions"
      :redraw="true"
      style="width: 100%; max-height: 400px;"
    />
  </div>
</template>

<script setup>
import { ref, watch, onMounted } from 'vue'
import axios from '@/services/axios'
import { Bar } from 'vue-chartjs'
import {
  Chart, BarElement, CategoryScale, LinearScale,
  Title, Tooltip, Legend
} from 'chart.js'

Chart.register(BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend)

const props = defineProps({
  dataInicio: { type: String, required: true },
  dataFim:    { type: String, required: true }
})

const chartData = ref({ labels: [], datasets: [] })

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,   // <-- adiciona esta linha
  plugins: {
    title: {
      display: true,
      text: 'Ranking: Forma de Contato',
      align: 'start'
    },
    legend: { display: false },
    tooltip: {
      callbacks: {
        // cada fatia
        label(ctx) {
          return `${ctx.label}: ${ctx.parsed.y}`
        },
        // rodapé: total das barras
        footer(ctxs) {
          const chart = ctxs[0].chart
          // soma todos os valores do primeiro dataset
          const total = chart.data.datasets[0].data
            .reduce((sum, v) => sum + v, 0)
          return `Total: ${total}`
        }
      },
      footerFont: { weight: 'bold' }
    }
  },
  scales: {
    x: { beginAtZero: true },
    y: { beginAtZero: true }
  }
}

async function fetchData() {
  try {
    const { data } = await axios.get(
      '/gestao/graficos/individuais/forma-contato',
      { params: { dataInicio: props.dataInicio, dataFim: props.dataFim } }
    )
    chartData.value = {
      labels: data.labels,
      datasets: [{
        label: 'Contagem',
        data: data.values,
        backgroundColor: '#4A90E2'
      }]
    }
  } catch (e) {
    console.error('Erro ao carregar ComercialChart1:', e)
  }
}

onMounted(fetchData)
watch(() => [props.dataInicio, props.dataFim], fetchData)
</script>

<style scoped>

.chart-container {
  width: 100%;
  /* altura em porcentagem do pai ou fixa, ajuste conforme necessidade */
  height: 300px;
}
@media (min-width: 768px) {
  .chart-container {
    height: 400px;
  }
}
</style>
